export Static from './Static';



/** WEBPACK FOOTER **
 ** ./src/FormControls/index.js
 **/